import {
  noFilters,
  getCategoryName,
  getSearchPageTitle,
  getRootPageTitle,
  getCategoryPageTitle,
} from './utils';

export default ({
  basePath = '', pageParameters = {}, promotedSearchTitle, pageMetaData = {},
}) => {
  const { category, searchTerm } = pageParameters;

  if (promotedSearchTitle || searchTerm) {
    return getSearchPageTitle(pageMetaData, promotedSearchTitle, searchTerm);
  }

  const categoryName = getCategoryName(category);
  if (noFilters(pageParameters) && categoryName === null) {
    return getRootPageTitle(basePath, pageMetaData);
  }

  return getCategoryPageTitle(basePath, pageMetaData, pageParameters);
};
